import {
  Box,
  Divider,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { useStore } from "@src/components/modules/projects/detail/Store/context";
import { CollapseIcon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";

const CardSectionHeader = () => {
  const store = useStore();

  return (
    <Grid
      alignItems="center"
      templateColumns={
        store.isReorderModeToggled
          ? "minmax(0, 0.55fr) 0.2fr 0.2fr 0.05fr"
          : store.project?.isTemplate
            ? "0.5fr 0.5fr"
            : "auto 0.325fr 0.15fr 0.125fr"
      }
      px="4"
      py="3"
      color="gray.600"
      borderBottom="1px"
      borderBottomColor="gray.300"
    >
      <HStack spacing="2.5">
        {store.isReorderModeToggled ? (
          <Box />
        ) : (
          <IconButton
            aria-label={t`toggle sub rows`}
            colorScheme="grey"
            onClick={() => store.subRowsOpen.toggle()}
            size="sm"
            variant="ghost"
          >
            <CollapseIcon />
          </IconButton>
        )}
        <Text fontWeight="semibold">
          <Trans>Budget item</Trans>
        </Text>
      </HStack>
      {store.isReorderModeToggled ? (
        <Fragment>
          <Text>
            <Trans>Done tasks</Trans>
          </Text>
          {store.project?.isTemplate ? (
            <GridItem />
          ) : (
            <Text>
              <Trans>Invoiced</Trans>
            </Text>
          )}
          <Text textAlign="end">
            <Trans>Visible</Trans>
          </Text>
        </Fragment>
      ) : (
        <Fragment>
          <HStack spacing="1.5">
            {!store.project?.isTemplate && (
              <>
                <Text>
                  <Trans>Tracked</Trans>
                </Text>
                <Divider h="3" borderColor="gray.400" orientation="vertical" />
              </>
            )}
            {/* TODO: Finish after API will be done */}
            {/* <Divider h="3" borderColor="gray.400" orientation="vertical" />
            <Text>
              <Trans>Allocated</Trans>
            </Text> */}
            <Box>
              <Text>
                <Trans>Budget</Trans>
              </Text>
            </Box>
          </HStack>
          {!store.project?.isTemplate && (
            <>
              <Text>
                <Trans>Invoiced (%)</Trans>
              </Text>
              <Text textAlign="end">
                <Trans>Uninvoiced</Trans>
              </Text>
            </>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default observer(CardSectionHeader);
